import React from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import { Loading } from './';

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgba(0,0,0,0.6);
    display: none;
    margin: ${props => props.margin};
    ${props => props.visible && `
        display: flex;
        align-items: center;
        justify-content: center;
    `}
`

export const LoadingOverlay = ({visible, margin}) => {
    
    return (
        <>
            {visible && (
                <Helmet>
                    <body className="loading" />
                </Helmet>
            )}
            <Overlay visible={visible} margin={margin}>
                <Loading width={150} height={150} light />
            </Overlay>
        </>
    )
}